import api from './axiosInstance';

/**
 * Resumen de SLA de escrituras EEPP (vista "Control SLA", submenú KPI).
 *
 * Backend: EscriturasIntakeController (GET /escrituras/sla/summary). Agrega el
 * SLA de todas las escrituras con reloj (SlaStartAt != null): por validador
 * (incluida una fila "Sin asignar" con userId null) y por etapa del flujo.
 *
 * Forma del DTO (EscriturasSlaSummaryDto):
 *   {
 *     generatedAt: "ISO",
 *     rows: [
 *       { userId: 12|null, userName: "..."|null,   // null = "Sin asignar"
 *         openCount, dueCount, closedOnTime, closedLate, avgCloseBusinessDays }
 *     ],
 *     dueByStage: [
 *       { stage: "recoleccion|redaccion|validacion|notaria", openCount, dueCount }
 *     ]
 *   }
 *
 * closedOnTime = cerradas a tiempo (SlaClosedAt <= SlaDueAt); las canceladas se
 * excluyen de todos los buckets; dueByStage solo trae etapas abiertas.
 */
export const getSlaSummary = async (signal) => {
  const response = await api.get('/escrituras/sla/summary', { signal });
  return response.data || {};
};
